import type { FaceterSettingsType } from '@/services/facets/types'
import { REFLECT_METADATA } from '@/decorators/types'

export function FaceterSettings(faceterSettings: FaceterSettingsType) {
  return function _<T extends { new (...args: any[]): Record<string, any> }>(constructor: T) {
    // save metadata on original constructor
    Reflect.defineMetadata(REFLECT_METADATA.FaceterSettings, faceterSettings, constructor)

    // add getFaceterSettings method to prototype instead of creating new class
    constructor.prototype.getFaceterSettings = function () {
      return faceterSettings
    }

    // return original constructor without changes
    return constructor
  }
}
